var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2H20V4H22V6H24V18H22V20H20V22H18V24H6V22H4V20H2V18H0V6H2V4H4V2H6V0H18Z",
    fill: "#2775CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6V7.71429H14.25V8.57143H15V10.2857H13.5V9.42857H12.75V8.57143H11.25V9.42857H10.5V10.2857H11.25V11.1429H12.75V12H14.25V12.8571H15V15.4286H14.25V16.2857H12.75V18H11.25V16.2857H9.75V15.4286H9V13.7143H10.5V14.5714H11.25V15.4286H12.75V14.5714H13.5V13.7143H12.75V12.8571H11.25V12H9.75V11.1429H9V8.57143H9.75V7.71429H11.25V6H12.75Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57143 4V4.875H5.85714V5.75H5.14286V6.625H4.42857V7.5H3.71429V8.375H3V15.625H3.71429V16.5H4.42857V17.375H5.14286V18.25H5.85714V19.125H6.57143V20H8V18.25H7.28571V17.375H6.57143V16.5H5.85714V15.625H5.14286V14.75H4.42857V9.25H5.14286V8.375H5.85714V7.5H6.57143V6.625H7.28571V5.75H8V4H6.57143Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4286 4V4.875H18.1429V5.75H18.8571V6.625H19.5714V7.5H20.2857V8.375H21V15.625H20.2857V16.5H19.5714V17.375H18.8571V18.25H18.1429V19.125H17.4286V20H16V18.25H16.7143V17.375H17.4286V16.5H18.1429V15.625H18.8571V14.75H19.5714V9.25H18.8571V8.375H18.1429V7.5H17.4286V6.625H16.7143V5.75H16V4H17.4286Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/USDC.e2127c703abe5ea1dcbeb8dfa592382b.svg";
export { ForwardRef as ReactComponent };